
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 32 26","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"32","height":"26","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAaCAQAAAB8kpa0AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLFw/3n2F7AAAB+UlEQVQ4y52Uz0sUYRzGnxkXRqx2C2SD9lIkpNXNUG8LJR0CcehUXYpIoyCQLh5iD/04eKhAMQztVOwlyOgPMPSSsGKkh37aRZBcWmNXatsJ5NNBt53ZnW139vtc5n3e93nm+8487ytUFTFu8hSHDIPVVxnIt27oig7prVY1pqheaku/9UiHFdYTvfKsrPBs4h4f2OAcJ/9x/XRyhl9Mcou8ixcVBmEm+YxNWxm/jxC7EGKKh+4Z09NOQl91QhdU0Lhe6L6GFZEkPdcPfdcpSdIRFaptoZOfnMbmGQWGecAUb3iNMEkQ4yrwjUsMksb030KCd8TJc5fLO8x+CoR2ng2Ocp4/HANifgbXcbAZYsKz9z1l3+Ixx0nxkZZyg4ukOYsw3O1VQRPvuc1ur0GSOzWFJQzxiVUObAdpVBEZ6peUUZA6qGUtK2ewpQltqEdWILkkfZGjayJDV4DmvegiY2pF7YHfXax2rZhaVHfDBt1aFH2s1fHr/GCyRp+wyNHbkEEvOSwhRphtyGCWke0gtbKJHVhus0lrMYkDrBMNJI+yzkApygbTzNNct7yZeaYx3GehhRQzhOuSh5khVTyPJTrCHEt01JR3sMQckeLYPWWRJF9xG3rRRp4kVokJuXLlKK0FZbX3P9nLakFpOf53ooiTpVZlibs1fwGvtOE52SxPdwAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    